import { render, staticRenderFns } from "./ProductItemUpdateScreen.vue?vue&type=template&id=56e3df59&"
import script from "./ProductItemUpdateScreen.vue?vue&type=script&lang=js&"
export * from "./ProductItemUpdateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports